import React, {Component} from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'shared/components/FormElements/DatePicker/index'
import {Button} from '@sabre/spark-react'
import {setLocalFlightDate, getLocalFlightDate} from 'shared/utils/localFlightDate'

import './styles/index.css'

export default class FlightsToolbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            flightDate: getLocalFlightDate()
        }
    }

    showFilters = () => {
        this.props.actions.showFilters()
    }

    onDateChange = (flightDate) => {
        this.setState({flightDate: flightDate})
        setLocalFlightDate(flightDate)
        this.props.actions.onDateChange(flightDate)
    }

    onPrevious = () => {
        this.setState({flightDate: this.state.flightDate.add(-1, 'day')})
    }

    onNext = () => {
        this.setState({flightDate: this.state.flightDate.add(1, 'day')})
    }

    render() {
        return (
            <div className="row spark-mar-b-1 flights-toolbar">
                <div className="col-lg-8 col-md-6 col-xs-12">
                    <div className="row">
                        <div className="col-md-11 col-xs-9">
                            <h2>{this.props.title}</h2>
                        </div>
                        <div className="col-md-1 col-xs-3 spark-text-right">
                            <Button onClick={() => this.showFilters()} icon="spark-icon-sliders" iconOnly/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-xs-12">
                    <div className="row">
                        <div className="col-md-2 col-xs-2 spark-text-right">
                            <Button onClick={() => this.onPrevious()} icon="spark-icon-arrow-triangle-left" iconOnly/>
                        </div>
                        <div className="col-md-8 col-xs-8">
                            <DatePicker value={this.state.flightDate} label="Flight Date"
                                        onChange={(flightDate) => this.onDateChange(flightDate)}/>
                        </div>
                        <div className="col-md-2 col-xs-2 spark-text-left">
                            <Button onClick={() => this.onNext()} icon="spark-icon-arrow-triangle-right" iconOnly/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FlightsToolbar.propTypes = {
    actions: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/screens/flights/components/FlightsToolbar/index.js